"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notify = void 0;
const error_1 = require("./error");
const lib_1 = require("./lib");
/**
 * Manually trigger a notification for a subject or one of its property without
 * requiring a property assignment.
 *
 * @param target the subject to notify
 * @param key optionally provide the observable property of `subject` to notify.
 *  If not provided, will notify observers of the subject itself.
 *
 * @throws if `target` is not a subject, or if `key` is not an observable
 * 	property of `target`.
 */
const notify = (target, key) => {
    const instance = lib_1.SubjectInstance.getOrNull(target);
    if (!instance) {
        throw new error_1.EcceError('Cannot notify non-subject.');
    }
    if (key) {
        const prop = instance.getProperty(key);
        if (!prop) {
            throw new error_1.EcceError(`Cannot notify non-observable property: "${instance.name}.${String(key)}".`);
        }
        prop.notify();
        return;
    }
    instance.notify();
};
exports.notify = notify;
//# sourceMappingURL=notify.js.map